<template>
  <section aria-label="Text Input">
    <div class="grid-row">
      <label class="usa-label" for="input-type-text">{{ label }}</label>
      <input
        class="usa-input"
        :id="label"
        name="input-type-text"
        type="text"
        :value="modelValue"
        @input="$emit('update:modelValue', $event.target.value)"
        v-on:keyup.enter="enterPressed"
      />
    </div>
  </section>
</template>

<script>
export default {
  name: "USWDSTextInput",
  emits: ["enterPressed", "update:modelValue"],
  props: {
    label: {
      type: String,
    },
    modelValue: {
      type: String,
    },
  },
  methods: {
    enterPressed() {
      this.$emit("enterPressed", this.currentValue);
    },
  },
};
</script>

<style scoped lang="scss">
input,
label {
  margin-left: 10px;
  margin-top: 0;
  height: 100%;
  margin-top: 5px;
}
</style>
